import type { IConfigObj } from '@makemydeal/dr-common-utils';
import type { SalesCheckinRootState } from '@makemydeal/dr-sales-checkin-store';

export const getConfig = (state: SalesCheckinRootState) => {
    return state.config;
};

export const getConfigServices = (state: SalesCheckinRootState) => {
    return getConfig(state).services;
};

export const getServicesBff = (state: SalesCheckinRootState) => {
    return getConfigServices(state).bff;
};

export const getConfigStaticImages = (state: SalesCheckinRootState): IConfigObj | undefined => {
    return getConfig(state).staticImages;
};
